/**
 * Sets up global error handlers to catch errors that React ErrorBoundary cannot catch:
 * - Unhandled promise rejections (fetch, async/await)
 * - Global JavaScript errors in event handlers
 * - Errors in setTimeout/setInterval callbacks
 */
export function setupGlobalErrorHandlers(options?: {
  onError?: (error: Error, source: 'unhandledrejection' | 'error') => void;
  logToConsole?: boolean;
}) {
  const { onError, logToConsole = true } = options ?? {};

  // Catch unhandled promise rejections (fetch, async/await)
  window.addEventListener('unhandledrejection', (event) => {
    const error =
      event.reason instanceof Error
        ? event.reason
        : new Error(String(event.reason));

    if (logToConsole) {
      console.error('Unhandled promise rejection:', error);
    }

    onError?.(error, 'unhandledrejection');

    // Prevent default browser error handling if needed
    // event.preventDefault();
  });

  // Catch global JavaScript errors (event handlers, setTimeout, etc.)
  window.addEventListener('error', (event) => {
    const error =
      event.error instanceof Error ? event.error : new Error(event.message);

    if (logToConsole) {
      console.error('Global error:', error);
    }

    onError?.(error, 'error');

    // Prevent default browser error handling
    event.preventDefault();
  });
}
